import { publicEnv } from "@/env/public-env";
import type { DormantSurface } from "@/lib/dormant-season/types";

const dormantSurfaces = new Set<DormantSurface>(
  publicEnv.NEXT_PUBLIC_DORMANT_SEASON,
);

export function isHiringSeasonDormant(surface: DormantSurface): boolean {
  return dormantSurfaces.has(surface);
}
